import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import { statusData } from "./dataColor";

const PurchaseRequisitionChart = ({ chartdata }) => {
  const chartRef = useRef(null);

  const defaultSeries = [{ name: "", data: [] }];
  const defaultCategories = [];

  const seriesData = chartdata?.series || defaultSeries;
  const categoriesData = chartdata?.categories || defaultCategories;

  const colors = seriesData.map((series) => {
    const status = statusData.find((item) => item.message === series.name);
    return status?.color || "#808080";
  });

  useEffect(() => {
    if (!chartRef.current) return;

    const options = {
      series: seriesData,
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "70%",
          borderRadius: 4,
        },
      },
      colors,
      xaxis: {
        categories: categoriesData,
      },
      dataLabels: { enabled: false },
      stroke: { show: true, width: 2, colors: ["transparent"] },
      fill: { opacity: 1 },
      tooltip: {
        y: {
          formatter: (val) => `Count ${val}`,
        },
      },
    };

    let chart = new ApexCharts(chartRef.current, options);
    chart.render();

    return () => chart.destroy();
  }, [seriesData, categoriesData, colors]); // ⚡ important

  return <div id="purchaseRequisitionChart" ref={chartRef}></div>;
};

export default PurchaseRequisitionChart;
